import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { Header } from "../../components/Header/Header";
import UploadDocumentModal from "../Contract/UploadDocumentModal";
import FilterModalForFolder from "./FilterModalForFolder";
import "./FolderContent.css";
import UploadModal from "./UploadModal";
import Cookies from "js-cookie";
import api from "../chat/api";
import { getOrFetchSubscriptionStatus } from "../../utils/subscriptionStatus";
const FolderContents = () => {
  const location = useLocation();
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const { folderName } = useParams();
  const [files, setFiles] = useState([]);
  const [folders, setFolders] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [renameInput, setRenameInput] = useState("");
  const [deletingDocId, setDeletingDocId] = useState(null);
  const navigate = useNavigate();
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const fileInputRef = useRef(null);
  const [isRenameFolderModalOpen, setIsRenameFolderModalOpen] = useState(false);
  const [isDeleteFolderModalOpen, setIsDeleteFolderModalOpen] = useState(false);
  const [currentFolder, setCurrentFolder] = useState(null);
  const [renameFolderInput, setRenameFolderInput] = useState("");
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [showBulkActions, setShowBulkActions] = useState(false);
  const [activeActionMenuFolder, setActiveActionMenuFolder] = useState(null);
  const dropdownRefs = useRef([]);
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const [hoveredAction, setHoveredAction] = useState(null);
  const [clickedAction, setClickedAction] = useState(null);
  const [filesToUpload, setFilesToUpload] = useState([]);
  const { pdfUrl, pdfKey } = location.state || {};
  const token = localStorage.getItem("token");
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const [isConfirmDeleteOpen, setIsConfirmDeleteOpen] = useState(false);
  const [isBulkDelete, setIsBulkDelete] = useState(false);
  const [isActionMenuOpen, setIsActionMenuOpen] = useState(null);
  const [selectedFilters, setSelectedFilters] = useState({
    folder: false,
    normalDocument: false,
    contract: false,
    invoice: false,
  });
  const [isRenameModalOpen, setIsRenameModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [currentFile, setCurrentFile] = useState(null);
  const [actionMenuPosition, setActionMenuPosition] = useState({
    top: 0,
    left: 0,
  });
  const [isDeleting, setIsDeleting] = useState(false);
  const [isExporting, setIsExporting] = useState(false);

  const folderId = new URLSearchParams(location.search).get("folderId");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [isPaidYearlyPlan, setIsPaidYearlyPlan] = useState(false);
  const [subscriptionChecked, setSubscriptionChecked] = useState(false);
  const [isRenamingDoc, setIsRenamingDoc] = useState(false);
  const [isRenamingFolder, setIsRenamingFolder] = useState(false);

  const [isHovered, setIsHovered] = useState(false);
  const actionMenuRef = useRef(null);
  const totalPages = Math.ceil((files.documents?.length || 0) / itemsPerPage);

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const showPopup = (type, message) => {
    alert(`${type}: ${message}`);
  };

  const toggleFolderActionMenu = (folder) => {
    setActiveActionMenuFolder((prevFolder) =>
      prevFolder === folder ? null : folder
    );
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };
  const [filters, setFilters] = useState({
    folder: true,
    normalDocument: true,
    contract: false,
    invoices: false,
  });

  const handleCancel = () => {
    setIsModalOpen(false);
    setIsFilterModalOpen(false);
  };

  useEffect(() => {
    if (isPopupVisible) {
      setActionMenuIndex(null);
    }
  }, [isPopupVisible]);

  const handleSortByDate = () => {
    setSortConfig((prev) => ({
      key: "date",
      direction:
        prev.key === "date" && prev.direction === "asc" ? "desc" : "asc",
    }));
  };

  const handleSortBySize = () => {
    setSortConfig((prev) => ({
      key: "size",
      direction:
        prev.key === "size" && prev.direction === "asc" ? "desc" : "asc",
    }));
  };

  const handleCheckboxChange = (fileId) => {
    setSelectedFiles((prevSelected) => {
      const updatedSelected = prevSelected.includes(fileId)
        ? prevSelected.filter((id) => id !== fileId)
        : [...prevSelected, fileId];

      setShowBulkActions(updatedSelected.length > 0);

      return updatedSelected;
    });
  };
  const [sortConfig, setSortConfig] = useState({
    key: null, // 'size' or 'date'
    direction: "asc", // or 'desc'
  });

  const handleSelectAll = () => {
    if (!files.documents || files.documents.length === 0) {
      setSelectedFiles([]);
      setShowBulkActions(false);
      return;
    }

    if (selectedFiles.length === files.documents.length) {
      setSelectedFiles([]);
      setShowBulkActions(false);
    } else {
      const allFileIds = files.documents.map((file) => file.id);
      setSelectedFiles(allFileIds);
      setShowBulkActions(true);
    }
  };
  const convertTimeAgoToSeconds = (timeAgo) => {
    const [value, unit] = timeAgo.split(" ");
    const number = parseInt(value);

    if (isNaN(number)) return Infinity;

    switch (unit.toLowerCase()) {
      case "second":
      case "seconds":
        return number;
      case "minute":
      case "minutes":
        return number * 60;
      case "hour":
      case "hours":
        return number * 3600;
      case "day":
      case "days":
        return number * 86400;
      default:
        return Infinity;
    }
  };

  useEffect(() => {
    const fetchSubscriptionStatus = async () => {
      try {
        const response = await getOrFetchSubscriptionStatus(api);

        if (response.status === 200) {
          const { subscription_type, plan_type } = response.data;
          const isYearly =
            subscription_type === "paid_subs" && plan_type === "yearly";
          setIsPaidYearlyPlan(isYearly);
          setSubscriptionChecked(true);
        }
      } catch (error) {
        console.error("Failed to fetch subscription status", error);
      }
    };

    if (token) {
      fetchSubscriptionStatus();
    }
  }, [token]);

  const [file, setFile] = useState(null);

  const handleFileChange = (event) => {
    const selected = Array.from(event.target.files || []);
    if (selected.length === 0) return;

    setFilesToUpload(selected);
    setIsModalOpen(true);
  };
  const handleApplyFilters = (newFilters) => {
    setFilters(newFilters);
  };

  const filteredDocuments = files.documents
    ? [...files.documents]
        .filter((file) =>
          file.name.toLowerCase().includes(searchQuery.toLowerCase())
        )
        .sort((a, b) => {
          if (!sortConfig.key) return 0;

          let aVal = a[sortConfig.key];
          let bVal = b[sortConfig.key];

          if (sortConfig.key === "date") {
            aVal = convertTimeAgoToSeconds(a.time_ago || "");
            bVal = convertTimeAgoToSeconds(b.time_ago || "");
          }

          if (sortConfig.key === "size") {
            // Parse sizes like "12 KB", "3.5 MB", etc. into bytes for proper comparison
            const parseSize = (sizeStr) => {
              if (!sizeStr) return 0;
              const [val, unit] = sizeStr.toUpperCase().split(" ");
              const num = parseFloat(val);
              const multiplier =
                unit === "KB"
                  ? 1024
                  : unit === "MB"
                  ? 1024 * 1024
                  : unit === "GB"
                  ? 1024 * 1024 * 1024
                  : 1;
              return num * multiplier;
            };

            aVal = parseSize(a.size);
            bVal = parseSize(b.size);
          }

          if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
          if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
          return 0;
        })
    : [];

  const clearFilters = async () => {
    try {
      // Reset filters
      setSelectedFilters({
        normalDocument: false,
        contract: false,
        invoice: false,
        spreadsheet: false,
      });

      const response = await api.get(
        `api/v1/readpdf/files-in-the-folder/${folderId}/`
      );

      if (response.status === 200) {
        const { documents, folders, folder_name } = response.data;

        setFiles({
          documents: documents.map((doc) => ({
            ...doc,
            key: doc.key || "",
            pdf_url: doc.url || "",
          })),
        });

        setFolders({ folder_name: folder_name || "N/A" });

        setIsFilterApplied(false);
      }
    } catch (error) {
      console.error("Error clearing filters:", error);
      setFiles({ documents: [] });
      setFolders({ folder_name: "N/A" });
    }
  };

  const RenameModal = ({ isOpen, onClose, onRename, fileName, loading }) => {
    const [newName, setNewName] = useState(fileName);
    useEffect(() => {
      if (isOpen) {
        setNewName(fileName); // 🔁 Sync name when modal opens
      }
    }, [isOpen, fileName]);
    const handleSubmit = () => {
      if (newName.trim() !== "") {
        onRename(newName);
      }
    };

    if (!isOpen) return null;

    return (
      <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center">
        <div className="rename-modal">
          <h2>Rename Document</h2>
          <p>Create a Custom Name for your Documents</p>
          <h3>Title</h3>
          <input
            type="text"
            value={newName}
            onChange={(e) => setNewName(e.target.value)}
            placeholder="Enter new name"
          />
          <div className="rename-modal-actions">
            <button onClick={onClose}>Cancel</button>
            <button onClick={handleSubmit} disabled={loading}>
              {loading ? "Saving..." : "Save"}
            </button>
          </div>
        </div>
      </div>
    );
  };

  const DeleteModal = ({ isOpen, onClose, onDelete, fileName, loading }) => {
    if (!isOpen) return null;

    return (
      <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center">
        <div className="document-popup-box-delete">
          <h2>Are you sure you want to delete the selected item(s)?</h2>
          <p under-folder-delete-popup>
            The selected item(s) will be removed from this folder. This action
            cannot be undone.
          </p>
          <div
            style={{
              display: "flex",
              gap: "8px",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <button
              onClick={() => onClose(null)}
              disabled={loading}
              className="document-popup-close-delete"
            >
              Cancel
            </button>
            <button
              onClick={onDelete}
              disabled={loading}
              className="document-popup-close-button ml-[-22px]"
            >
              {loading ? "Deleting..." : "Delete"}
            </button>
          </div>
        </div>
      </div>
    );
  };

  const handleRenameFolder = async (newName) => {
    if (!newName) {
      showPopup("Error", "Folder name is required.");
      return;
    }

    setIsRenamingFolder(true);
    try {
      const response = await api.put(
        `api/v1/readpdf/rename-folder/${currentFolder.id}/`,
        { new_name: newName }
      );

      if (response.status === 200) {
        await fetchFiles();
        setIsRenameFolderModalOpen(false);
        showPopup("Success", "Folder renamed successfully.");
      }
    } catch (error) {
      console.error("Error renaming folder:", error);
      showPopup("Error", "Failed to rename folder. Please try again.");
    } finally {
      setIsRenamingFolder(false);
    }
  };

  const handleDeleteFolder = async (folderId) => {
    try {
      const response = await api.delete(
        `api/v1/readpdf/delete-folder/${folderId}/`
      );

      if (response.status === 204) {
        setFolders((prevFolders) =>
          prevFolders.filter((folder) => folder.id !== folderId)
        );
        setIsDeleteFolderModalOpen(false);
        showPopup("Success", "Folder deleted successfully.");
      } else {
        showPopup("Error", "Failed to delete folder. Please try again.");
      }
    } catch (error) {
      console.error("Error deleting folder:", error);
      showPopup("Error", "Failed to delete folder. Please try again.");
    }
  };
  const toggleFilterModal = () => {
    setIsFilterModalOpen((prev) => !prev);
  };

  const handleFolderActionClick = (action, folder) => {
    setCurrentFolder(folder);
    if (action === "rename") {
      setRenameFolderInput(folder.name);
      setIsRenameFolderModalOpen(true);
    } else if (action === "delete") {
      setIsDeleteFolderModalOpen(true);
    }
  };

  const fetchFiles = async () => {
    try {
      const response = await api.get(
        `api/v1/readpdf/files-in-the-folder/${folderId}/`
      );

      if (response.status === 200) {
        const updatedDocuments = response.data.documents.map((doc) => ({
          ...doc,
          pdf_url: doc.url || "",
        }));
        setFiles({ ...response.data, documents: updatedDocuments });
        setFolders({ folder_name: response.data.folder_name });
      } else {
      }
    } catch (error) {
      console.error("Error fetching files:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFiles();
  }, [folderId]);

  const popupRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isActionMenuOpen !== null &&
        actionMenuRef.current &&
        !actionMenuRef.current.contains(event.target)
      ) {
        setIsActionMenuOpen(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isActionMenuOpen]);

  const handleImageClick = () => {
    setIsPopupVisible(!isPopupVisible);
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };
  const [actionMenuIndex, setActionMenuIndex] = useState(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        actionMenuIndex !== null &&
        dropdownRefs.current[actionMenuIndex] &&
        !dropdownRefs.current[actionMenuIndex].contains(event.target)
      ) {
        setActionMenuIndex(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [actionMenuIndex]);

  const toggleActionMenu = (index, event) => {
    event.stopPropagation();
    if (isActionMenuOpen === index) {
      setIsActionMenuOpen(null);
    } else {
      const rect = event.currentTarget.getBoundingClientRect();
      setActionMenuPosition({
        top: rect.bottom + window.scrollY + 6, // Adjust spacing
        left: rect.left + window.scrollX - 20, // Shift left slightly if needed
      });
      setIsActionMenuOpen(index);
    }
  };

  useEffect(() => {
    const limit = isPaidYearlyPlan ? 10 : 5;

    if (subscriptionChecked && files.documents?.length > limit) {
      setIsPopupVisible(true);
    } else {
      setIsPopupVisible(false);
    }
  }, [files.documents, isPaidYearlyPlan, subscriptionChecked]);

  const paginatedDocuments = filteredDocuments.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  if (loading) return <p>Loading folder contents...</p>;

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  const handleBulkDelete = async () => {
    if (selectedFiles.length === 0) {
      alert("No files selected for deletion");
      return;
    }

    try {
      setIsDeleting(true);

      const response = await api.delete(
        `api/v1/readpdf/bulk-delete-from-folder/${folderId}/`,
        { data: { document_ids: selectedFiles } }
      );

      if (response.status === 200) {
        const { removed_documents, not_found_documents } = response.data;
        const updatedDocuments = files.documents.filter(
          (doc) =>
            !removed_documents.some((removed) => removed.document_id === doc.id)
        );
        setFiles((prevFiles) => ({
          ...prevFiles,
          documents: updatedDocuments,
        }));
        const updatedSelectedFiles = selectedFiles.filter(
          (id) =>
            !removed_documents.some((removed) => removed.document_id === id)
        );
        setSelectedFiles(updatedSelectedFiles);

        if (updatedSelectedFiles.length === 0) {
          setShowBulkActions(false);
        }
        if (not_found_documents.length > 0) {
          console.error(
            `Some documents could not be removed:`,
            not_found_documents
          );
        }
      } else {
        console.error("Failed to delete documents. Please try again.");
      }
    } catch (error) {
      console.error("Error deleting documents:", error);
    } finally {
      setIsDeleting(false);
    }
  };

  const handleBulkExport = async () => {
    if (selectedFiles.length === 0) {
      alert("No files selected for export");
      return;
    }

    try {
      setIsExporting(true);

      const token = localStorage.getItem("token");

      const selectedFileObjects = files.documents.filter((file) =>
        selectedFiles.includes(file.id)
      );

      const contractKeys = selectedFileObjects
        .filter((file) => file.type === "contract" || file.type === "invoice")
        .map((file) => file.key);

      if (contractKeys.length === 0) {
        alert(
          "Export is only available for contracts. Please select at least one contract."
        );
        return;
      }

      const response = await api.post(
        `api/v1/readpdf/export-doc/`,
        { contract_keys: contractKeys },
        { responseType: "blob" }
      );

      const blob = new Blob([response.data], { type: "text/csv" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "exported_documents.csv";
      link.click();

      setSelectedFiles([]);
      setShowBulkActions(false);
    } catch (error) {
      console.error(
        "Error exporting files:",
        error.response?.data || error.message
      );
      alert("An error occurred while exporting files. Please try again.");
    } finally {
      setIsExporting(false);
    }
  };

  const handleUploadSuccess = () => {
    const limit = isPaidYearlyPlan ? 10 : 5;

    if (subscriptionChecked && files.documents?.length > limit) {
      setIsPopupVisible(true);
      return;
    }

    fetchFiles();
    handleCloseModal();
  };

  const handleRename = async (newName) => {
    if (!currentFile) return;
    setIsRenamingDoc(true);
    try {
      const response = await api.put(
        `api/v1/readpdf/rename-doc/${currentFile.id}/`,
        { new_name: newName }
      );
      if (response.status === 200) {
        await fetchFiles();
        setIsRenameModalOpen(false);
      }
    } catch (error) {
      console.error("Error renaming document:", error);
    } finally {
      setIsRenamingDoc(false);
    }
  };

  const handleDelete = async () => {
    if (!currentFile) return;

    try {
      setIsDeleting(true);
      const token = localStorage.getItem("token");
      const response = await api.delete(
        `api/v1/readpdf/bulk-delete-from-folder/${folderId}/`,
        {
          data: { document_ids: [currentFile.id] }, // Pass as array
        }
      );

      if (response.status === 200) {
        fetchFiles();
        setIsDeleteModalOpen(false);
      } else {
        console.error("Failed to delete document.");
      }
    } catch (error) {
      console.error("Error deleting document:", error);
    } finally {
      setIsDeleting(false); // ✅ Stop loading
    }
  };

  return (
    <div className="Contents-Full-Container">
      <div>
        <Header icon={"/arrow-back.svg"} name="Go to Documents" />
      </div>
      <div className="folder-content-info">
        <div className="main-content">
          <img
            src="/folder-icon-folder.svg"
            alt="Folder Icon"
            className="folder-icon"
          />
          <h2 className="folder-name-underfolder">
            {folders.folder_name || "N/A"}
          </h2>
        </div>

        <div className="action-buttons-content">
          {selectedFiles.length === 0 && (
            <>
             
              <div className="upload-container-invoice">
                <button
                  className="upload-button-content"
                  onMouseEnter={() => {
                    setIsTooltipVisible(true);
                  }}
                  onMouseLeave={() => {
                    setIsTooltipVisible(false);
                  }}
                  onClick={() => fileInputRef.current.click()}
                  disabled={
                    subscriptionChecked &&
                    files.documents?.length > (isPaidYearlyPlan ? 10 : 5)
                  }
                >
                  <img src="/upload_white.svg" alt="Upload" />
                  Upload
                </button>

                {isTooltipVisible && (
                  <div
                    className={`upload-tooltip-invoice absolute top-[138px] left-[93%] transform -translate-x-1/2 
                w-[178px] h-[92.637px] flex-shrink-0 bg-contain bg-no-repeat 
                pt-[10px] px-[20px] font-outfit text-[16px] font-normal leading-[8px] text-[#171717] 
                whitespace-nowrap z-[1000] flex opacity-${
                  isTooltipVisible ? "100" : "0"
                } 
                ${
                  isTooltipVisible ? "visible" : "invisible"
                } transition-opacity duration-200 ease-in-out`}
                    style={{
                      backgroundImage: "url('/path-to-background.svg')",
                    }}
                  >
                    <p className="text-[#171717] font-outfit text-[13px] font-normal leading-normal w-[99px] h-[27px] flex-shrink-0">
                      Supported formats:
                      <br /> Pdf,Txt, Csv, Xls,Docx <br /> Xlsx,Jpg,Jpeg,Png
                      <br />
                      Maximum Size : 25MB
                    </p>
                  </div>
                )}

                <input
                  id="fileInput"
                  ref={fileInputRef}
                  type="file"
                  multiple
                  style={{ display: "none" }}
                  accept=".pdf,.xls,.xlsx,.csv,.txt,.doc,.jpeg,.jpg,.png"
                  onChange={handleFileChange}
                />
              </div>
            </>
          )}
        </div>
      </div>

      <div className="document-search-filter-container">
        <div
          className="document-search-boxs"
          style={{
            borderRadius: "20px",
            border: isSearchFocused
              ? "1px solid rgba(187, 66, 174, 0.36)"
              : "1px solid var(--black_stroke, rgba(0, 0, 0, 0.10))",
            background: "#FFF",
            boxShadow: isSearchFocused
              ? "0px 11px 3px 0px rgba(0, 0, 0, 0.00), 0px 7px 3px 0px rgba(0, 0, 0, 0.01), 0px 4px 2px 0px rgba(0, 0, 0, 0.05), 0px 2px 2px 0px rgba(0, 0, 0, 0.09), 0px 0px 1px 0px rgba(0, 0, 0, 0.10)"
              : "none",
            transition: "all 0.3s ease-in-out",
          }}
        >
          <img src="/search.svg" alt="" />
          <input
            type="text"
            placeholder="Search Documents Here"
            className="document-input-space"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onFocus={() => setIsSearchFocused(true)}
            onBlur={() => setIsSearchFocused(false)}
          />
        </div>
        <div className="relative group inline-block">
          <button
            className={`button-filter-doc-button bg-white border ${
              isFilterApplied
                ? "border-[rgba(187,66,174,0.36)]"
                : "border-[rgba(0,0,0,0.10)]"
            }`}
            onClick={toggleFilterModal}
          >
            <img
              src="/filter-icon-first.svg"
              alt="Filter Icon"
              className="inline-block mr-2"
            />
            <span className="filter-text-button">Filter</span>
          </button>

          {isFilterApplied && (
            <img
              src="/Filter_CTA.svg"
              alt="Clear Filter"
              className="absolute bottom-6 -right-1 w-5 h-5"
              onClick={clearFilters}
            />
          )}

          {isFilterApplied && (
            <div className="absolute top-[106%] left-1/2 -translate-x-1/2 z-50 min-w-[140px] rounded-md bg-white shadow-lg border border-gray-200 px-4 py-3 text-sm text-gray-700 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
              <div className="font-semibold mb-1">Filters Applied</div>
              <ul className="list-disc pl-5 space-y-1">
                {selectedFilters.normalDocument && <li>All Documents</li>}
                {selectedFilters.folder && <li>Folders</li>}
                {selectedFilters.contract && <li>Contracts</li>}
                {selectedFilters.invoice && <li>Invoices</li>}
                {selectedFilters.spreadsheet && <li>Spreadsheets</li>}
              </ul>
            </div>
          )}
        </div>

        {showBulkActions && (
          <div className="bulk-action-bar">
            <button
              onClick={handleBulkExport}
              disabled={
                selectedFiles.length === 0 ||
                !files.documents.some(
                  (file) =>
                    selectedFiles.includes(file.id) &&
                    (file.type === "contract" || file.type === "invoice")
                )
              }
              className="bulk-action-button export-button"
            >
              {isExporting ? (
                <>
                  <img
                    src="/export-icon-blue.svg" // 🔄 optional spinner icon
                    alt="Exporting..."
                    // className="w-4 h-4 animate-spin"
                  />
                  <span className="export-spna ml-1">Exporting...</span>
                </>
              ) : (
                <>
                  <img
                    src="/export-icon-blue.svg"
                    alt="Export"
                    className="button-icon"
                  />
                  <span className="export-spna">Export</span>
                </>
              )}
            </button>

            <button
              onClick={() => {
                setIsBulkDelete(true);
                setIsConfirmDeleteOpen(true);
              }}
              disabled={selectedFiles.length === 0}
              className="bulk-action-button delete-button"
            >
              <img
                src="/delete-icon-red.svg"
                alt="Delete"
                className="button-icon"
              />
              <span className="delete-spna">Delete</span>
            </button>

            <button
              onClick={() => {
                setSelectedFiles([]);
                setShowBulkActions(false);
              }}
              className="bulk-action-button cancel-button"
            >
              <span>X</span>
            </button>
          </div>
        )}
      </div>
      <div
        className="container-doc overflow-y-auto bg-white rounded-md shadow-sm border border-gray-100"
        style={{ marginLeft: "216px", marginTop: "12px" }}
      >
        <table className="w-full table-fixed text-sm text-left">
          <thead className="bg-[#F9F9F9] h-[51px] text-[#1E1E1E] font-medium border-b border-[rgba(0,0,0,0.10)]">
            <tr>
              <th className="w-[40px] px-3">
                <input
                  type="checkbox"
                  className="custom-checkbox"
                  style={{
                    appearance: "none",
                    border: "1.5px solid #c0c0c0",
                    borderRadius: "4px",
                    cursor: "pointer",
                    backgroundImage:
                      files.documents?.length > 0 &&
                      selectedFiles?.length === files.documents.length
                        ? "url('/checck.svg')"
                        : "none",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "20px 20px",
                  }}
                  checked={
                    files.documents?.length > 0 &&
                    selectedFiles?.length === files.documents.length
                  }
                  onChange={handleSelectAll}
                  disabled={!files.documents?.length}
                />
              </th>

              <th className="w-[300px] px-3 file-size-of-heading">File Name</th>
              <th className="w-[150px] px-3 file-size-of-heading">File Type</th>

              <th className="w-[100px] px-3 file-size-of-heading">
                <div
                  className="flex items-center gap-2 cursor-pointer"
                  onClick={handleSortBySize}
                >
                  <span>Size</span>
                  <img
                    src="/icons-size-icon.svg"
                    alt="Size Icon"
                    className="w-4 h-4"
                  />
                </div>
              </th>
              <th className="w-[100px] px-3 file-size-of-heading">
                <div
                  className="flex items-center gap-2 cursor-pointer"
                  onClick={handleSortByDate}
                >
                  <span>Uploaded Date</span>
                  <img
                    src="/icons-size-icon.svg"
                    alt="Date Icon"
                    className="w-4 h-4"
                  />
                </div>
              </th>
              <th className="w-[110px] px-3 file-size-of-heading"></th>
              <th className="w-[40px] px-3 file-size-of-heading"></th>
            </tr>
          </thead>
          <tbody>
            {files.documents && files.documents.length > 0 ? (
              paginatedDocuments.map((file, index) => (
                <tr
                  key={file.id}
                  className="h-[44px] border-b border-[rgba(0,0,0,0.10)] hover:bg-gray-50 transition"
                >
                  <td className="px-3">
                    <input
                      type="checkbox"
                      className="custom-checkbox"
                      style={{
                        appearance: "none",
                        border: "1.5px solid #c0c0c0",
                        borderRadius: "4px",
                        cursor: "pointer",
                        backgroundImage: selectedFiles.includes(file.id)
                          ? "url('/checck.svg')"
                          : "none",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "20px 20px",
                      }}
                      checked={selectedFiles.includes(file.id)}
                      onChange={() => handleCheckboxChange(file.id)}
                    />
                  </td>

                  <td className="px-3 truncate">
                    <div className="flex items-center gap-2">
                      <img
                        src={
                          file.documents
                            ? "/folder-icon-new.svg"
                            : file.file_type === "pdf"
                            ? "/pdff.svg"
                            : file.file_type === "xlsx"
                            ? "/Xls.svg"
                            : file.file_type === "docx"
                            ? "/docX.svg"
                            : file.file_type === "csv"
                            ? "/CSV.svg"
                            : file.file_type === "txt"
                            ? "/TXT.svg"
                            : file.file_type === "xls"
                            ? "/Xls.svg"
                            : "/pdf.svg"
                        }
                        className="w-5 h-5"
                        alt="Icon"
                      />
                      <span className="truncate file-size-of-subheading">
                        {file.name || "N/A"}
                      </span>
                    </div>
                  </td>

                  <td className="px-3 file-size-of-subheading">{file.type}</td>
                  <td className="px-3 file-size-of-subheading">{file.size}</td>
                  <td>
                    <span className="px-3 file-size-of-subheading">
                      {file.uploaded_at}
                    </span>
                  </td>
                  <td className="px-3 file-size-of-subheading">
                    <button
                      onClick={() => {
                        navigate("/chat", {
                          state: {
                            pdfUrl: file.pdf_url,
                            pdfKey: file.key,
                            pdfId: file.id,
                          },
                        });
                      }}
                      onMouseEnter={() => setIsHovered(true)}
                      onMouseLeave={() => setIsHovered(false)}
                      className="flex items-center gap-1 text-purple-500 font-medium chat-button-documents-for"
                    >
                      <img
                        src={
                          isHovered
                            ? "/chat-icon-doc-hover.svg"
                            : "/chat-icon-doc.svg"
                        }
                        className="w-4 h-4"
                        alt="Chat"
                      />
                      Chat
                    </button>
                  </td>
                  <td className="px-3 relative">
                    <img
                      src="/action.svg"
                      alt="Actions"
                      width="20"
                      height="20"
                      onClick={(e) => toggleActionMenu(index, e)}
                      style={{ cursor: "pointer" }}
                    />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="no-documents-message-cell">
                  <div className="no-documents-container flex flex-col items-center justify-center mr-2rem">
                    <img
                      src="/no-contracts.svg"
                      alt="No Documents Found"
                      className="no-documents-icon mb-4"
                    />
                    <p className="no-documents-message text-center text-gray-500">
                      Looks like your Table is empty!
                    </p>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {/* {filteredDocuments.length > 0 && (
    <div className="pagination" style={{ width: "80.3vw",marginBottom: "-4.8rem"}}>
    <div className="pagination-dropdown">
      <select
        value={currentPage}
        onChange={(e) => setCurrentPage(Number(e.target.value))}
        className="page-selector"
      >
        {Array.from({ length: totalPages }, (_, index) => (
          <option key={index} value={index + 1}>
            {index + 1}
          </option>
        ))}
      </select>
    </div>
    <p className="contentDown">of {totalPages} pages</p>
    <button
      onClick={handlePreviousPage}
      disabled={currentPage === 1}
      style={{
        cursor: currentPage === 1 ? "not-allowed" : "pointer",
      }}
    >
      <img
        src="/decrease.svg"
        alt="Previous Page"
        style={{ height: "12px", width: "12px" }}
      />
    </button>
    <button
      onClick={handleNextPage}
      disabled={currentPage === totalPages}
      style={{
        cursor:
          currentPage === totalPages ? "not-allowed" : "pointer",
      }}
    >
      <img
        src="/increase.svg"
        alt="Next Page"
        style={{ height: "12px", width: "12px" }}
      />
    </button>
  </div>
  )} */}
      </div>

      {isPopupVisible && (
        <div className="popup-container-underfolder">
          <div className="popup-content-folder">
            <h2>Oops! Maximum Limit Reached</h2>
            <p>
              This folder allows a maximum of {isPaidYearlyPlan ? 10 : 5}{" "}
              documents. To upload more, please delete an existing document.
            </p>
            <button
              className="popup-close-button-folder"
              onClick={() => setIsPopupVisible(false)}
            >
              Got It
            </button>
          </div>
        </div>
      )}

      {loading && (
        <div className="loading-indicator">Deleting documents...</div>
      )}

      <FilterModalForFolder
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        onApply={(filteredFiles, filteredFolders) => {
          setFiles(filteredFiles);
          setFolders(filteredFolders);
          setIsFilterApplied(true); // ✅ Mark filter as applied
        }}
        setFiles={setFiles}
        setFolders={setFolders}
        setIsFilterApplied={setIsFilterApplied}
        // ✅ Ensure filter status updates
        folderId={folderId}
        src="folder"
        selectedFilters={selectedFilters}
        setSelectedFilters={setSelectedFilters} // ✅ Ensure filter status updates
        clearFilters={clearFilters}
      />

      <UploadModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onUploadSuccess={handleUploadSuccess}
        folderId={folderId}
        type={"underFolder"}
        file={filesToUpload}
      />

      <RenameModal
        isOpen={isRenameModalOpen}
        onClose={() => setIsRenameModalOpen(false)}
        onRename={handleRename}
        fileName={renameInput}
        loading={isRenamingDoc}
      />

      <DeleteModal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        onDelete={handleDelete}
        fileName={currentFile ? currentFile.name : ""}
        loading={isDeleting} // ✅ passed
      />

      <RenameModal
        isOpen={isRenameFolderModalOpen}
        onClose={() => setIsRenameFolderModalOpen(false)}
        onRename={handleRenameFolder}
        fileName={renameFolderInput}
        loading={isRenamingFolder}
      />

      <DeleteModal
        isOpen={isConfirmDeleteOpen}
        onClose={() => setIsConfirmDeleteOpen(false)}
        onDelete={async () => {
          if (isBulkDelete) {
            await handleBulkDelete();
          } else {
            await handleDelete();
          }
          setIsConfirmDeleteOpen(false);
        }}
        fileName={
          isBulkDelete
            ? `${selectedFiles.length} selected document(s)`
            : currentFile?.name || ""
        }
        loading={isDeleting}
      />

      {isActionMenuOpen !== null && (
        <div
          className="document-action-menu fixed z-[9999] bg-white shadow-md rounded-md"
          ref={actionMenuRef}
          style={{
            height: "95px",
            top:
              isActionMenuOpen >= paginatedDocuments.length - 0
                ? `${actionMenuPosition.top - 130}px`
                : `${actionMenuPosition.top}px`,
            left: `${actionMenuPosition.left}px`,
          }}
        >
          <>
            {/* Rename */}
            <div
              className="flex items-center space-x-1 w-13 h-10 mt-1 ml-1"
              onMouseEnter={() => setHoveredAction("rename")}
              onMouseLeave={() => setHoveredAction(null)}
              onMouseDown={() => setClickedAction("rename")}
              onMouseUp={() => setClickedAction(null)}
              onClick={(e) => {
                e.stopPropagation();
                setCurrentFile(paginatedDocuments[isActionMenuOpen]);
                setRenameInput(
                  paginatedDocuments[isActionMenuOpen]?.name || ""
                );
                setIsRenameModalOpen(true);
                setIsActionMenuOpen(null);
              }}
              style={{
                color:
                  clickedAction === "rename"
                    ? "#C95EBE"
                    : hoveredAction === "rename"
                    ? "#C95EBE"
                    : "",
                background:
                  clickedAction === "rename" || hoveredAction === "rename"
                    ? "#FAF9F6"
                    : "transparent",
                padding: "10px",
                borderRadius: "8px",
                cursor: "pointer",
              }}
            >
              <img
                src={
                  clickedAction === "rename" || hoveredAction === "rename"
                    ? "/edit-active-contract.svg"
                    : "/edit.svg"
                }
                alt="Edit Icon"
                className="document-action-icon"
              />
              <p>Rename</p>
            </div>

            {/* Delete */}
            <div
              className="flex items-center space-x-1 w-13 h-10 mt-1 ml-1"
              onMouseEnter={() => setHoveredAction("delete")}
              onMouseLeave={() => setHoveredAction(null)}
              onMouseDown={() => setClickedAction("delete")}
              onMouseUp={() => setClickedAction(null)}
              onClick={(e) => {
                e.stopPropagation();
                setCurrentFile(paginatedDocuments[isActionMenuOpen]);
                setIsBulkDelete(false);
                setIsConfirmDeleteOpen(true);
                setIsActionMenuOpen(null);
              }}
              style={{
                color:
                  clickedAction === "delete"
                    ? "#E74C3C"
                    : hoveredAction === "delete"
                    ? "#E74C3C"
                    : "#000",
                background:
                  clickedAction === "delete" || hoveredAction === "delete"
                    ? "#FAF9F6"
                    : "transparent",
                padding: "10px",
                borderRadius: "8px",
                cursor: "pointer",
              }}
            >
              <img
                src={
                  clickedAction === "delete" || hoveredAction === "delete"
                    ? "/delete-active-contract.svg"
                    : "/delete.svg"
                }
                alt="Delete Icon"
                className="document-action-icon"
              />
              <p>Delete</p>
            </div>
          </>
        </div>
      )}
    </div>
  );
};

export default FolderContents;
